import { StyleFunctionProps } from '@telescope/cassini-ui';

export const inputTheme = {
  variants: {
    outline: (props: StyleFunctionProps) => {
      const { errorColorScheme: c } = props.theme.settings;

      return ({
        field: {
          _focusVisible: { borderColor: 'focus', boxShadow: '0 0 0 1px var(--cassini-colors-focus)' },
          _invalid: {
            borderColor: `${c}.500`,
            boxShadow: `0 0 0 1px ${c}.500`,
          }
        },
      })
    }
  },
};